<div
  class="card-form-group-container"
  [formGroup]="form">
  <app-input-vocabulary-autocomplete
    formControlName="PRVS"
    #PRVSElement
    [vocabularyName]="'V_PRV'"
    [openVocabulary]="false"
    [parentTerm]="null"
    [placeholder]="'Stato (PRVS)'">
  </app-input-vocabulary-autocomplete>
  <app-input-vocabulary-autocomplete
    #PRVRElement
    formControlName="PRVR"
    [vocabularyName]="'V_PRV'"
    [parentTerm]="PRVSElement?.extendedValue"
    [openVocabulary]="false"
    [placeholder]="'Regione (PRVR)'">
  </app-input-vocabulary-autocomplete>
  <app-input-vocabulary-autocomplete
    #PRVPElement
    formControlName="PRVP"
    [vocabularyName]="'V_PRV'"
    [parentTerm]="PRVRElement?.extendedValue"
    [openVocabulary]="false"
    [placeholder]="'Provincia (PRVP)'">
  </app-input-vocabulary-autocomplete>
  <app-input-vocabulary-autocomplete
    formControlName="PRVC"
    [vocabularyName]="'V_PRV'"
    [parentTerm]="PRVPElement?.extendedValue"
    [openVocabulary]="false"
    [placeholder]="'Comune (PRVC)'">
  </app-input-vocabulary-autocomplete>
  <mat-form-field>
    <input
      matInput
      placeholder="Località (PRVL)"
      formControlName="PRVL">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      placeholder="Altra ripartizione amministrativa (PRVE)"
      formControlName="PRVE">
  </mat-form-field>
</div>
